<div class="appointment-control-title d-flex justify-content-between align-items-center flex-wrap">
    <div>Programare {{ cerere.type_denumire }}</div>
    <div class="appointment-status" [ngClass]="appointment.status">
        {{ renderStatus(appointment.status) }}</div>
</div>
<div class="appointment-contents d-flex flex-column" *ngIf="!editing">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <div class="appointment-holder">
                {{cerere.cetatean?.nume}} {{cerere.cetatean?.prenume}}
            </div>
            <div class="appointment-date">{{ appointment.date | date:'dd-MM-yyyy' }} {{ appointment.time_from }}</div>
        </div>
        <div *ngIf="!readonly" class="appointment-buttons-container d-flex gap-2">
            <button mat-icon-button color="accent" matTooltip="Anulează"
                *ngIf="appointment.status !== 'rejected'" (click)="cancel()">
                <mat-icon>clear</mat-icon>
            </button>
            <button mat-icon-button color="primary" matTooltip="Reprogramează" (click)="editing = true"
                *ngIf="appointment.status !== 'rejected'">
                <mat-icon>update</mat-icon>
            </button>
            <button mat-icon-button class="confirm-button" *ngIf="appointment.status !== 'confirmed'"
                [matTooltip]="appointment.status === 'rejected' ? 'Reinstituie' : 'Confirmă'"
                (click)="confirm()">
                <mat-icon>check</mat-icon>
            </button>
        </div>
    </div>
    <!-- <div *ngIf="appointment.message && appointment.status === 'rejected'" class="appointment-message" matTooltip="Motivul anulării">
        <small>{{appointment.message}}</small>
    </div> -->
</div>

<div class="appointment-contents" *ngIf="editing">
    <div class="d-flex flex-column">
        <mat-form-field class="app-form-field" color="primary" (click)="appointmentDatepicker.open()">
            <mat-label>Data</mat-label>
            <input matInput [matDatepicker]="appointmentDatepicker" (dateChange)="getAvailableSlots()"
                [matDatepickerFilter]="calendarFilter" [min]="todayMoment.toDate()" [max]="endOfYearMoment.toDate()"
                [(ngModel)]="date" />
            <mat-datepicker-toggle matSuffix [for]="appointmentDatepicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #appointmentDatepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Ora</mat-label>
            <mat-select [(value)]="time">
                <mat-option *ngFor="let option of slots" [value]="option">
                    {{option}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!-- <div class="d-flex gap-2">
        <button mat-stroked-button (click)="editing = false; appointment = initaialAppointment">
            <span>RENUNȚĂ</span>
        </button>
        <button mat-raised-button color="primary" (click)="modify()" [disabled]="hasChanged">
            <mat-icon style="margin-right: 5px; margin-left: -10px; transform: scale(0.8)">save</mat-icon>
            <span>SALVEAZĂ</span>
        </button>
    </div> -->
</div>